import styled, { css } from "styled-components"

export const CompteurItem = styled.div`
  align-items: ${props => (props.fontAlignement ? props.fontAlignement : "flex-start")};
  justify-content: center;
  flex-direction: column;
  display: flex;
  height: 100%;
`

export const ValueAndPeriod = styled.div`
  justify-items: ${props => (props.fontAlignement ? props.fontAlignement : "flex-start")};
  grid-template-rows: ${({ hasLabel }) => (hasLabel ? "50% 50%" : "100%")};
  align-items: center;
  display: grid;
  height: 100%;
`

export const ValuesContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: ${props => (props.fontAlignement ? props.fontAlignement : "flex-start")};
  color: ${props => (props.fontColor ? props.fontColor : "#000")};
`

export const SeparatorBetweenComparedValues = styled.div`
  border-right: ${({ fontColor }) => (fontColor ? `1px solid ${fontColor}` : "1px solid #000000")};
  margin: 5px;
`

export const Period = styled.div``

export const Value = styled.div`
  font-size: ${props => (props.fontSize ? props.fontSize : "1rem")};
  font-weight: ${props => (props.fontWeight ? props.fontWeight : "bold")};
`

export const Label = styled.div`
  overflow: auto;
  color: ${props => (props.labelColor ? props.labelColor : "#000")};
  font-size: ${props => (props.labelSize ? props.labelSize : "1rem")};
  font-weight: ${props => (props.labelWeight ? props.labelWeight : "bold")};
  justify-content: ${props => (props.fontAlignement ? props.fontAlignement : "flex-start")};
  flex-direction: row;
  display: flex;
  width: 100%;
  height: 100%;
`

export const IconContainer = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  height: 100%;
  width: fit-content;
  padding: 0 10px;
  i {
    opacity: ${({ iconOpacity }) => iconOpacity && iconOpacity};
    font-size: ${({ iconFontSize }) => (iconFontSize ? iconFontSize : "1rem")};
    color: ${({ iconColor }) => (iconColor ? iconColor : "#707070")};
  }

  ${({ isMobile }) =>
    isMobile &&
    css`
      i {
        font-size: ${({ iconFontSize }) => (iconFontSize ? iconFontSize : "1rem")};
      }
    `}
`
